import { Notification } from "./notificationTypes";
import { apiQueryAdapter } from "../apiQueryAdapter";

class NotificationService {
  private static instance: NotificationService;

  private constructor() {}

  static getInstance(): NotificationService {
    if (!NotificationService.instance) {
      NotificationService.instance = new NotificationService();
    }
    return NotificationService.instance;
  }

  async getRecentNotifications(email: string): Promise<Notification[]> {
    // Use real API endpoint
    try {
      const response = await apiQueryAdapter.query(`/emp-notifications/inapp/email/${email}/recent`, "GET");
      return response.data;
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
      return [];
    }
  }

  async markNotificationAsRead(deliveryId: string): Promise<void> {
    try {
      await apiQueryAdapter.query(`/emp-notifications/delivery/${deliveryId}/read`, "PUT");
    } catch (error) {
      console.error('Failed to mark notification as read:', error);
      throw error;
    }
  }

  async markAllNotificationsAsRead(email: string): Promise<void> {
    try {
      await apiQueryAdapter.query(`/emp-notifications/inapp/email/${email}/read-all`, "PUT");
    } catch (error) {
      console.error('Failed to mark all notifications as read:', error);
      throw error;
    }
  }
}

export default NotificationService;
